import router from '@/router';

const OCRoutes = [
  {
    path: 'projects',
    name: 'Project',
    component: {
      name: 'AdminProjects',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'project',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminProjectsIndex',
        component: () => import('../views/ProjectsIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminProjectNew',
        component: () => import('../views/ProjectInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminProjectsIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminProjectShow',
        component: () => import('../views/ProjectShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminProjectsIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminProjectDetails',
            component: () => import('../views/ProjectDetails.vue'),
            meta: {
              backRoute: { name: 'AdminProjectsIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminProjectEdit',
            component: () => import('../views/ProjectInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminProjectDetails' },
            },
          },
          {
            path: 'quotations',
            name: 'AdminProjectQuotations',
            component: () => import('../views/ProjectQuotations.vue'),
            meta: {
              backRoute: { name: 'AdminProjectsIndex' },
              resource: 'quotation',
            },
          },
          {
            path: 'subscriptions',
            name: 'AdminProjectSubscriptions',
            component: () => import('../views/ProjectSubscriptions.vue'),
            meta: {
              backRoute: { name: 'AdminProjectsIndex' },
              resource: 'subscription',
            },
          },
          {
            path: 'rentals',
            name: 'AdminProjectRentals',
            component: () => import('../views/ProjectRentals.vue'),
            meta: {
              backRoute: { name: 'AdminProjectsIndex' },
              resource: 'rental',
            },
          },
          {
            path: 'attachments',
            name: 'AdminProjectAttachments',
            component: () =>
              import('../views/attachment/ProjectAttachments.vue'),
            meta: {
              backRoute: { name: 'AdminProjectsIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'attachments/edit',
            name: 'AdminProjectAttachmentsEdit',
            component: () =>
              import('../views/attachment/ProjectAttachmentsInput.vue'),
            meta: {
              backRoute: { name: 'AdminProjectAttachments' },
              resource: 'attachment',
              action: 'edit',
            },
          },
          {
            path: 'send',
            name: 'AdminProjectSendEmail',
            component: () => import('../views/ProjectSendEmail.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminProjectIndex' },
              customName: 'views.project.send_email_template',
            },
          },
          {
            path: 'phases',
            name: 'AdminProjectPhases',
            component: () => import('../views/ProjectPhases.vue'),
            meta: {
              backRoute: { name: 'AdminProjectsIndex' },
              resource: 'phase',
            },
          },
          {
            path: 'jobs',
            name: 'AdminProjectJobs',
            component: () => import('../views/ProjectJobs.vue'),
            meta: {
              backRoute: { name: 'AdminProjectsIndex' },
              resource: 'job',
            },
          },
          {
            path: 'invoices',
            name: 'AdminProjectInvoices',
            component: () => import('../views/ProjectInvoices.vue'),
            meta: {
              backRoute: { name: 'AdminProjectsIndex' },
              resource: 'invoice',
            },
          },
          {
            path: 'purchase_orders',
            name: 'AdminProjectPurchaseOrders',
            component: () => import('../views/ProjectPurchaseOrders.vue'),
            meta: {
              backRoute: { name: 'AdminProjectsIndex' },
              resource: 'purchase_order',
            },
          },
          {
            path: 'sub_projects',
            name: 'AdminProjectSubProjects',
            component: {
              name: 'AdminSubProject',
              render(h) {
                return h('router-view');
              },
            },
            meta: {
              resource: 'sub_project',
            },
            get redirect() {
              return this.children[0];
            },
            children: [
              {
                path: '',
                name: 'AdminSubProjectIndex',
                component: () =>
                  import('../views/subProject/ProjectSubProjects.vue'),
                meta: {
                  backRoute: { name: 'AdminProjectsIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminSubProjectNew',
                component: () =>
                  import('../views/subProject/SubProjectInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminProjectsIndex' },
                },
              },
            ],
          },
          {
            path: 'connector_exports',
            name: 'AdminProjectConnectorExports',
            component: () => import('../views/ProjectConnectorExports.vue'),
            meta: {
              backRoute: { name: 'AdminProjectsIndex' },
              resource: 'connector_export',
            },
          },
          {
            path: 'logs',
            name: 'AdminProjectLogs',
            component: () => import('../views/ProjectLogs.vue'),
            meta: {
              backRoute: { name: 'AdminProjectIndex' },
              resource: 'log',
            },
          },
          /* ------- Sent custom template mails ------- */
          {
            path: 'sent_custom_template_mails',
            name: 'AdminProjectSentCustomTemplateMail',
            component: {
              name: 'AdminProjectSentCustomTemplateMail',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminProjectDetails' },
              resource: 'sent_custom_template_mail',
            },
            children: [
              {
                path: '',
                name: 'AdminProjectSentCustomTemplateMailIndex',
                component: () =>
                  import(
                    '../views/sentCustomTemplateMail/SentCustomTemplateMails.vue'
                  ),
                meta: {
                  backRoute: { name: 'AdminProjectDetails' },
                },
              },
              {
                path: ':sentCustomTemplateMailId(\\d+)',
                name: 'AdminProjectSentCustomTemplateMailShow',
                component: () =>
                  import(
                    '../views/sentCustomTemplateMail/SentCustomTemplateMailShow.vue'
                  ),
                meta: {
                  backRoute: {
                    name: 'AdminProjectSentCustomTemplateMail',
                  },
                  tArgs: route => ({
                    name: route.params?.sentCustomTemplateMailId,
                  }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminProjectSentCustomTemplateMailDetails',
                    component: () =>
                      import(
                        '../views/sentCustomTemplateMail/SentCustomTemplateMailDetails.vue'
                      ),
                    meta: {
                      backRoute: {
                        name: 'AdminProjectSentCustomTemplateMailIndex',
                      },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

const pubRoutes = [
  {
    path: '/public/projects',
    name: 'PublicProject',
    component: {
      name: 'PublicProject',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'project',
      layout: 'Public',
      publicRoute: true,
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: ':id(\\d+)',
        name: 'PublicProjectShow',
        component: () => import('../views/public/ProjectPublicShow.vue'),
        meta: {
          layout: 'Public',
          publicRoute: true,
        },
      },
    ],
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));
pubRoutes.forEach(route => router.addRoute(route));
